module.exports = __webpack_public_path__ + "dabdc67430200668edf772d2a872d24b.svg";